:host {
  * {
    box-sizing: border-box;
  }
}

.SideMenuButton {
  display: flex;
  align-items: center;
  justify-content: center;
  height: var(--navbar-height);
  margin-inline-start: calc(var(--pdt-space-100) * -1);
  margin-top: calc(var(--pdt-space-200) * -1);
  margin-bottom: calc(var(--pdt-space-200) * -1);
  padding: 0 var(--pdt-space-100);
  border-right: 1px solid var(--pdt-color-border-subtle);

  .iconContainer {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    flex: 0 0 20px;
  }

  pwc-icon-shadow {
    position: absolute;
    left: 0;
    top: 0;
    transition: opacity .1s ease;

    &[icon="cross"] {
      opacity: 0;
    }

    &[icon="nav-menu"] {
      opacity: 1;
    }
  }

  &--active {
    eco-suite-navbar-button:hover {
      pwc-icon-shadow {
        &[icon="cross"] {
          opacity: 1;
        }

        &[icon="nav-menu"] {
          opacity: 0;
        }
      }
    }
  }
}
